<template>
  <div id="main">
    <div class="nav">
      <div class="nav-top">
        <a class="nav-hamburger" v-on:click="ClickHamburger" ref=hamburger><span></span></a>
      <div class="nav-profile">
        <img class="nav-avatar" src="../../assets/logo.png">
        <div class="nav-name-role">
        <div class="nav-user-name">{{profile.name}}</div>
        <div class="nav-user-role">{{profile.role}}</div>
      </div>
      <div class="nav-avatar-menu"><button class="nav-avatar-menu-content" @click="$emit('OnLogOut')">Logout</button></div></div></div>
      <div class="nav-items" ref=items>
        <div class="nav-item" v-for="(item, index) in items" :key="index" v-bind:class="{active: index === selectedNav}" @click="$emit('update:selectedNav', index)">
          <a class="nav-item-a">
            <div class="nav-item-icon"><i class="fa" :class="item.icon"></i></div>
            <div class="nav-item-desc">{{item.title}}</div>
          </a>
        </div>
      </div>
    </div>
    <div class="nav-content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
		profile:Object,
    items:Array,
    isLoggedIn:Boolean,
    selectedNav:Number
  },
	methods: {
    ClickHamburger: function(e) {
			this.$refs.hamburger.classList.toggle('active');
			this.$refs.items.classList.toggle('nav-items');
			this.$refs.items.classList.toggle('nav-items-expanded');
		},
  }
}
</script>

<style scoped>
#main {
  margin: 0.4em;
  padding: 0;
  display: -webkit-flex;
  display: flex;
  -webkit-flex-flow: row;
  flex-flow: row;
  border-radius: 3px;
  overflow: hidden;
}
.nav,
.nav-content {
  padding: 0.5em;
}
.nav {
  background: #001b3d;
  -webkit-flex: 1;
  flex: 1;
}
.nav-item {
  color: white;
  border-bottom: 1px solid rgb(255,255,255,.1);
  cursor: pointer;
}
.nav-item-a {
  display: -webkit-flex;
  display: flex;
  -webkit-flex-flow: column;
  flex-flow: column;
  align-items: center;
  transition: transform .5s;
}
.nav-item.active {
  background-color: #39A2D9;
}
.nav-item-a:hover {
  transform: translateX(5px);
}
.nav-item-icon {
  font-size: 30px;
  width: 80px;
  text-align: center;
}
.nav-item-desc {
  -webkit-flex: 1;
  flex: 1;
}
.nav-profile {
  text-align: center;
  padding: 1rem 1rem;
  border-bottom: 1px solid rgb(255,255,255,.1);
  position: relative;
}
.nav-avatar {
  width: 80px;
  padding: 5px;
  border: 1px solid white;
}
.nav-avatar-menu {
  background: #39a2d9;
  box-shadow: 0 2px 15px 0 rgba(45, 130, 255, 0.15);
  position: absolute;
  width: 100%;
  top:0px;
  left:0px;
  overflow: hidden;
  opacity: 0;
  transition: all 0.3s ease;
  display: -webkit-flex;
  display: flex;
  -webkit-flex-flow: column;
  flex-flow: column;
}
.nav-avatar-menu-content {
  height:50px;
  color:#001b3d;
  padding: 10px;
  border:none;
  border-top: 1px solid rgb(255,255,255,.1);
  flex:1 1 auto;
  background: #39a2d9;
}
.nav-avatar-menu-content:hover {
  color: white;
}
.nav-avatar-menu:hover {
  opacity: 1;
}
.nav-user-name {
  display: block;
  font-size: 1.1rem;
  color: white;
  text-transform: capitalize;
}
.nav-user-role {
  display: block;
  font-size: 0.8rem;
  text-transform: uppercase;
  color: rgba(255, 255, 255, .5);
}
.nav-hamburger {
  padding-top: 20px;
  display: none;
}
.nav-hamburger span, .nav-hamburger span:before, .nav-hamburger span:after {
  cursor: pointer;
  border-radius: 1px;
  height: 5px;
  width: 35px;
  background: white;
  position: absolute;
  display: block;
  content: '';
  transition: all 500ms ease;
}
.nav-hamburger span:before {
  top: -10px;
}
.nav-hamburger span:after {
  bottom: -10px;
}
.nav-hamburger.active span {
  background-color: transparent;
}
.nav-hamburger.active span:before, .nav-hamburger.active span:after {
  top: 0;
}
.nav-hamburger.active span:before {
  transform: rotate(45deg);
}
.nav-hamburger.active span:after {
  transform: rotate(-45deg);
}
.nav-content {
  background: white;
  -webkit-flex: 5;
  flex: 5;
  min-height: 98.5vh;
}
@media all and (max-width: 1024px) {
  #main {
    margin: 0;
    border-radius: 0;
  }
  .nav-name-role {
    display: none;
  }
}
@media all and (max-width: 640px) {
  #main {
    -webkit-flex-flow: column;
    flex-flow: column;
  }
  .nav-items, .nav-items-expanded {
    overflow:hidden;
    transition:all .3s;
  }
  .nav-items {
    max-height: 0px;
  }
  .nav-items-expanded {
    max-height: 500px;
  }
  .nav-item-a {
    -webkit-flex-flow: row;
    flex-flow: row;
  }
  .nav-hamburger {
    display: block;
    cursor: pointer;
  }
  .nav-avatar {
    width:40px;
    border-radius: none;
  }
  .nav-top {
    display:flex;
    justify-content: space-between;
    align-items: flex-start;
  }
  .nav-profile {
    padding: 0;
    padding-top: 2px;
    border: none;
  }
  .nav-avatar-menu {
    width: 100px;
    height: 100px;
    top:0px;
    left:-60px;
  }
}
@media only screen
and (min-width : 640px)
and (max-width : 1024px)  {
  .nav-avatar {
    width:50px;
  }
  .nav-item-desc {
    display: none;
  }
  .nav-content {
    -webkit-flex: 7;
    flex: 7;
  }
}
</style>
